module.exports = __webpack_public_path__ + "img/28_26.497d860a.png";